import PopupCore from './popup-core';
import {dataset} from '../helpers';

export default class PhonePopUp extends PopupCore {

    getActionText() {
        return dataset(this.element, 'actionText', `Call ${this.element.innerText}`)
    }

    getActionIcon() {
        return '<svg style="height: 15px; width: 15px;" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>';
    }

}
